module.exports = __webpack_public_path__ + "img/circle_offline adv.7808f644.svg";